import { Smileys } from "iconsax-react";

const FEATURES = [
  {
    icon: <Smileys />,
    gradient: "91deg, #F40BEA 18.41%, #CCB80A 99%",
    title: "HOST AN EVENT ",
    desc: "With Protein Box, you can host a healthy event for marriages, parties & any other functions",
  },
  {
    icon: <Smileys />,
    gradient: "91deg, #FFF 18.41%, #A0A0A0 61.56%, #FFF 99%",
    title: "CORPORATE MEAL PLANS ",
    desc: "Increase health productivity of your employees with special corporate discount with corporate meal plans",
  },
  {
    icon: <Smileys />,
    title: "LOW CARB HIGH PROTEIN MEALS ",
    gradient: "91deg, #F4DC0B 18.41%, #8C843D 99%",
    desc: "Specially curated your fat loss journey",
  },
  {
    icon: <Smileys />,
    gradient: "90deg, #21FC79 0.04%, rgba(248, 252, 33, 0.69) 106.51%",
    title: "PRO ATHLETE & BODYBUILDING PREP MEALS",
    desc: "Fuel your bodybuilding prep with Protein box custom curated macro based meals",
  },
  {
    icon: <Smileys />,
    gradient: "91deg, #F4DC0B 18.41%, #8C843D 99%",
    title: "CARE MEALS ",
    desc: "Now get super light, super healthy meal with high quality & safe ingredients for the elderly &  tasty retreats for the kids",
  },
  {
    icon: <Smileys />,
    gradient: "90deg, #33A5E5 0.04%, rgba(248, 252, 33, 0.69) 106.51%",
    title: "BUSINESS WITH PROTEIN BOX ",
    desc: "Setup Protein Box healthy counter/kitchen in your office cafeteria, gym or co-working space",
  },
];

export default FEATURES;
